import { useState } from "react";
import { Card, CardBody, Col, Input, InputGroup } from "reactstrap";
import { Btn } from "../../../../AbstractElements";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { ButtonsWithPrefixAndPostfixs, PostText, PreText } from "../../../../Constant";
import { TOUCHSPIN_DATA } from "../../../../Data/FormWidgets";

const ButtonsWithPrefixAndPostfix = () => {
  const [values, setValues] = useState([0, 0]);
  const handleIncrement = (index: number) => {
    setValues((previousValues) => {
      return previousValues.map((value, i) => (i === index ? value + 1 : value));
    });
  };
  const handleDecrement = (index: number) => {
    setValues((previousValues) => {
      return previousValues.map((value, i) => (i === index && value > 0 ? value - 1 : value));
    });
  };
  return (
    <Col xl="12">
      <Card>
        <CommonCardHeader title={ButtonsWithPrefixAndPostfixs}  span={TOUCHSPIN_DATA} />
        <CardBody className="common-flex pre-post-touchspin bg-touchspin">          
          <InputGroup>
            <Btn color="success" className="decrement-touchspin btn-touchspin" onClick={() => handleDecrement(0)}>
              <i className="fa fa-minus"></i>
            </Btn>
            <Btn color="success" outline id="button-addon1" type="button">
              {PreText}
            </Btn>
            <Input className="input-touchspin spin-outline-primary" type="number" value={values[0]} readOnly />
            <Btn color="success" className="increment-touchspin btn-touchspin" onClick={() => handleIncrement(0)}>
              <i className="fa fa-plus"> </i>
            </Btn>
          </InputGroup>
          <InputGroup>
            <Btn color="success" className="decrement-touchspin btn-touchspin" onClick={() => handleDecrement(1)}>
              <i className="fa fa-minus"></i>
            </Btn>
            <Input className="input-touchspin spin-outline-primary" type="number" value={values[1]} readOnly />
            <Btn color="success" outline id="button-addon2" type="button">
              {PostText}
            </Btn>
            <Btn color="success" className="increment-touchspin btn-touchspin" onClick={() => handleIncrement(1)}>
              <i className="fa fa-plus"></i>
            </Btn>
          </InputGroup>
        </CardBody>
      </Card>
    </Col>
  );
};

export default ButtonsWithPrefixAndPostfix;
